import React, { useState, useEffect } from 'react';
import { CoinAnimationStyles as styles } from '../css/styles';
import { coinIcon } from '../constants/icons';
import classNames from 'classnames'
import { soundEngine } from '../utils/soundEngine';


interface CoinAnimationProps {
  currentCoins: number;
  coinsToAward: number;
  setCoinAnimationFinished: (finished: boolean) => void;
  // testTurnedOn: boolean;
}



const CoinAnimation: React.FC<CoinAnimationProps> = ({ currentCoins, coinsToAward, setCoinAnimationFinished }) => {
  const [displayedCoins, setDisplayedCoins] = useState(currentCoins);
  const [showAward, setShowAward] = useState(false); // Controls visibility of +coins
  const [hideCoins, setHideCoins] = useState(false); // Controls hiding of currentCoins
  const [fadeOut, setFadeOut] = useState(false); // Controls the fade-out animation
  const [finalBounce, setFinalBounce] = useState(false);
  
  // useEffect(() => {
  //   const end = currentCoins + coinsToAward;

  //   if (coinsToAward > 0) {
  //     // Step 1: Show currentCoins with coin icon (already displayed by default)
  //     setDisplayedCoins(currentCoins);

  //     // Step 2: Hide currentCoins, show +coinsToAward
  //     const showCoinsAwardTimeout = setTimeout(() => {
  //       setHideCoins(true); // Hide currentCoins temporarily
  //       setShowAward(true); // Show +coinsToAward
  //     }, 1000); // After 1 second

  //     // Step 3: Remove coinsToAward and start incrementing currentCoins
  //     const startIncrementTimeout = setTimeout(() => {
  //       setShowAward(false); // Hide +coinsToAward
  //       setHideCoins(false); // Show currentCoins back
  //       let start = currentCoins;

  //       playCoinSound();

  //       const increment = () => {
  //         if (start < end) {
  //           start += 1;
  //           setDisplayedCoins(start);
  //           setTimeout(increment, 50); // Increment speed
  //         }
  //       };
  //       increment();
  //     }, 2000); // Increment starts 1 second after coinsToAward is shown

  //     // Step 4: Fade everything out
  //     const fadeOutTimeout = setTimeout(() => {
  //       setFadeOut(true); // Trigger fade out
  //     }, 3500); // Fade out 1.5 seconds after increment starts

  //     setTimeout(() => {
  //       setCoinAnimationFinished(true);
  //     }, 3500);

  //     // Cleanup timers
  //     return () => {
  //       clearTimeout(showCoinsAwardTimeout);
  //       clearTimeout(startIncrementTimeout);
  //       clearTimeout(fadeOutTimeout);
  //     };
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [currentCoins, coinsToAward]);


  const step = Math.max(1, Math.floor(coinsToAward / 30));
  const delay = Math.max(20, 60 - Math.floor(coinsToAward / 10));

  useEffect(() => {
    if (coinsToAward <= 0) return;

    const INCREMENT_DELAY = 50;
    const SHOW_CURRENT_DELAY = 1000;
    const SHOW_AWARD_DELAY = 1000;
    const FADE_BUFFER = 1000;
    const FINAL_HOLD_DELAY = 1000;
    const FINAL_BOUNCE_DURATION = 400;

    const end = currentCoins + coinsToAward;
    const incrementDuration = coinsToAward * INCREMENT_DELAY;

    setDisplayedCoins(currentCoins);

    const showCoinsAwardTimeout = setTimeout(() => {
      setHideCoins(true);
      setShowAward(true);
    }, SHOW_CURRENT_DELAY);

    const startIncrementTimeout = setTimeout(() => {
      setShowAward(false);
      setHideCoins(false);

      let current = currentCoins;
      soundEngine.play('coin')

      const increment = () => {
        if (current < end) {
          current = Math.min(current + step, end);
          setDisplayedCoins(current);
          setTimeout(increment, delay);
        } else {
          // Trigger final bounce
          setFinalBounce(true);

          // Remove class so it can be reused next time
          setTimeout(() => {
            setFinalBounce(false);
          }, FINAL_BOUNCE_DURATION);

          // Fade out AFTER bounce + hold
          setTimeout(() => {
            setFadeOut(true);
            setCoinAnimationFinished(true);
          }, FINAL_BOUNCE_DURATION + FINAL_HOLD_DELAY);
        }
      };

      increment();
    }, SHOW_CURRENT_DELAY + SHOW_AWARD_DELAY);

    const fadeOutTimeout = setTimeout(() => {
      setFadeOut(true);
      setCoinAnimationFinished(true);
    }, SHOW_CURRENT_DELAY + SHOW_AWARD_DELAY + incrementDuration + FADE_BUFFER);

    return () => {
      clearTimeout(showCoinsAwardTimeout);
      clearTimeout(startIncrementTimeout);
      clearTimeout(fadeOutTimeout);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentCoins, coinsToAward]);

  return (
    <div className={classNames(styles.coinContainer, {[styles.fadeOut] : fadeOut})} >
      <div className={styles.coinDisplay}>
        <img src={coinIcon} alt="Coin Icon" />
        {!hideCoins && (
          <span
            className={classNames({
              [styles.finalBounce]: finalBounce,
            })}
          >
            {displayedCoins}
          </span>
        )}
        {showAward && coinsToAward > 0 && (
          <span className={styles.coinsAwarded}>+{coinsToAward}</span> 
        )}
      </div>
    </div>
  );
};

export default CoinAnimation;